import React from 'react'
import debounce from 'lodash.debounce'
import { firstBy } from 'thenby'
import { TaxReturnTile } from '../../components/tax-return-tile'
import { dataSources } from '../../utils/data-sources'
import { PortalContainer } from '../../components/portal-container'
import { inject, observer } from 'mobx-react'
import Http from '../../services/http'
import PropTypes from 'prop-types'
import { SessionStore } from '../../stores'
import { Placeholder } from '../../components/placeholder'
import Router from 'next/router'

@inject('sessionStore')
@observer
class UnsubmittedReturns extends React.Component {
  constructor (props) {
    super(props)
    this.http = Http.getInstance(this.props.sessionStore)
    this.dataSources = dataSources()
    this.onSearchDebounced = debounce(() => this.search(), 250)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.state = {
      ready: false,
      viewData: null,
      filteredData: null,
      registeredName: null,
      query: null
    }
    this.searchInputRef = React.createRef()
  }
  loadData () {
    return this.http.getData(this.dataSources.taxReturns)
  }

  componentDidMount () {
    if (this.props.isReconciliation) {
      if (this.props.sessionStore.isFullEdition) {
        this.loadData().then((viewData) => {
          if (viewData.status === 'success') {
            const readytoSubmit = viewData.data.filter(item => {
              return (item.Reconciliation !== null && !['Submitted', 'Submission in progress'].includes(item.status))
            })
            const readytoSub = readytoSubmit.map(item => {
              return {
                registrationNumber: item.TaxRegistration.registrationNumber,
                taxRegistrationId: item.TaxRegistration.id,
                registeredName: item.TaxRegistration.registeredName,
                reconciliationId: item.Reconciliation.id,
                finishDate: item.periodEnd,
                startDate: item.periodStart,
                status: item.status,
                reconciliationStatus: item.Reconciliation.status,
                id: item.id
              }
            })
            readytoSub.sort(
              firstBy('finishDate')
                .thenBy('registrationNumber')
            )
            this.setState({
              ready: true,
              viewData: readytoSub
            }, () => {
              this.setup()
            })
          } else {
            const viewData = []
            this.setState({
              viewData,
              ready: true
            })
          }
        }).catch((e) => {
          console.error(e)
          const viewData = []
          this.setState({
            viewData,
            ready: true
          })
        })
      } else {
        Router.push('/unauthorised')
      }
    } else {
      this.loadData().then((viewData) => {
        if (viewData.status === 'success') {
          const readytoSubmit = viewData.data.filter(item => item.status === 'Ready to submit')
          const readytoSub = readytoSubmit.map(item => {
            return {
              registrationNumber: item.TaxRegistration.registrationNumber,
              taxRegistrationId: item.TaxRegistration.id,
              finishDate: item.periodEnd,
              startDate: item.periodStart,
              status: item.status,
              id: item.id
            }
          })
          readytoSub.sort(
            firstBy('finishDate')
              .thenBy('registrationNumber')
          )
          this.setState({
            ready: true,
            viewData: readytoSub
          }, () => this.setup())
        } else {
          const viewData = []
          this.setState({
            viewData,
            ready: true
          })
        }
      }).catch((e) => {
        console.error(e)
        const viewData = []
        this.setState({
          viewData,
          ready: true
        })
      })
    }
  }

  setup = () => {
    this.searchInputRef.current.addEventListener('input', (e) => { this.onSearchChange(e) })
  }

  onSearchChange (e) {
    this.setState({ query: e.target.value })
    this.onSearchDebounced()
  }

  search () {
    const filter = this.state.query
    const matchesFilter = new RegExp(filter, 'i')
    const tempData = [...this.state.viewData]
    const filteredData = tempData.filter(item => !filter || matchesFilter.test(item.registrationNumber))
    this.setState({
      filteredData
    }, () => {
      this.setup()
    })
  }

  getData () {
    return this.state.filteredData ? this.state.filteredData : this.state.viewData
  }

  getSearchComponent () {
    return (
      <PortalContainer parentContainer='page-header-search'>
        <mosaic-form prevent-default>
          <mosaic-search-input
            placeholder='Search'
            value={this.state.query}
            ref={this.searchInputRef}

          >
            <mosaic-button
              class='mt-0 ml-0'
              icon='search'
              color='secondary'
            >
            </mosaic-button>

          </mosaic-search-input>

        </mosaic-form>
      </PortalContainer>
    )
  }

  cancelButtonClick = () => {
    Router.push('/')
  }

  getHeaderButton () {
    return (
      <PortalContainer parentContainer='btn-container'>
        <mosaic-button icon='cancel' class='ml-1' color='secondary' onClick={this.cancelButtonClick}>Close</mosaic-button>
      </PortalContainer>
    )
  }

  render () {
    const pageHeaderSearch = document.getElementById('page-header-search')
    const btnContainer = document.getElementById('btn-container')
    if (this.state.ready && pageHeaderSearch && btnContainer) {
      const viewData = this.getData()
      if (viewData.length === 0) {
        return (
          <div className='pb-4'>
            {this.getSearchComponent()}
            {this.getHeaderButton()}
            <p className='mb-0'>There are no results related to your search.</p>
          </div>
        )
      } else {
        return (
          <React.Fragment>
            {this.getSearchComponent()}
            {this.getHeaderButton()}
            <mosaic-row>
              {viewData.map((r) => <TaxReturnTile key={r.registrationNumber} {...r} taxRegistrationId={r.taxRegistrationId}
                registeredName={r.registeredName} reconciliationStatus={r.reconciliationStatus} isAudit={this.props.isAudit} isReconciliation={this.props.isReconciliation} />)}
            </mosaic-row>
          </React.Fragment>
        )
      }
    } else {
      return <Placeholder />
    }
  }
}

UnsubmittedReturns.defaultProps = {
  isAudit: false,
  isReconciliation: false
}

UnsubmittedReturns.propTypes = {
  sessionStore: PropTypes.instanceOf(SessionStore),
  isAudit: PropTypes.bool,
  isReconciliation: PropTypes.bool
}

export { UnsubmittedReturns }
